import {type UIGameManager} from '../UIGameManager.ts'
import {ActionState, TileHexType, TurnState} from '@colonist/game-states'
import {type TileCorner, type TileHex} from '@colonist/game-mechanic-validators'

export class UIGameInitialPlacementsConfirmationController {
    private readonly uiGameManager: UIGameManager

    constructor(uiGameManager: UIGameManager) {
        this.uiGameManager = uiGameManager
    }

    highlightNeighborTilesAndPorts(index: number) {
        if(!this.isPlacingSettlementOrCity()) return

        const corner: TileCorner = this.uiGameManager.gameState.mapState.tileState.tileCorners[index]
        const neighborHexFaces = corner.hexCorner.touchingFaces()
        for(const hexFace of neighborHexFaces) {
            const tileType = this.uiGameManager.gameState.mapState.tileState.getTileHex(hexFace)?.tileType
            const notAllowedTileHexType = [TileHexType.Desert, TileHexType.Sea, TileHexType.Fog]
            if(tileType == undefined) continue
            if(notAllowedTileHexType.includes(tileType)) continue

            const tileView = this.uiGameManager.mapController.getTileViewForHexFace(hexFace)
            tileView?.highlightWithWhiteSurrounding()
        }
        this.uiGameManager.mapController.portController.highlightPort(corner.hexCorner)
    }

    removeNeighborTilesAndPortsHighlights() {
        const tiles = this.uiGameManager.gameState.mapState.tileState.tiles
        tiles.forEach((tile: TileHex) => this.uiGameManager.mapController.getTileViewForHexFace(tile.hexFace)?.resetHighlightWithWhiteSurrounding())
        this.uiGameManager.mapController.portController.removePortHighlight()
    }

    private isPlacingSettlementOrCity(): boolean {
        if(this.uiGameManager.gameController.currentState.turnState != TurnState.InitialPlacement) return false
        const validAction = this.uiGameManager.gameController.currentState.actionState == ActionState.InitialPlacementPlaceSettlement || this.uiGameManager.gameController.currentState.actionState == ActionState.InitialPlacementPlaceCity
        if(!validAction) return false
        return true
    }
}
